import { CATEGORY_COLOR_SET, POSITIONINGMAP_COLOR_SET } from "../../../config/ColorSet";

const arrayCompare = (arr1, arr2) => {
  for (let i = 0; i < arr1.length || i < arr2.length; i++) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
    else {
      continue;
    }
  }
  return true;
}
const JSONtoReportData = (data, options) => {
  let retDataJson = {};
  let retDataSet = [];
  let start_date = new Date(data.dateRange[0].toString().replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3'));
  let end_date = new Date(data.dateRange[1].toString().replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3'));
  let diff_date = (end_date.getTime() - start_date.getTime()) / (1000 * 60 * 60 * 24);

  const channel = data.channel;

  if (data.report_type === "volume") {
    const tab_length = data.data.length / channel.length;

    for (let i = 0; i < tab_length; i++) {
      let pushItem;
      if (data.sub_query_type === "cross") {
        pushItem = {
          "query": data.data[i][0].info.query,
          "channel": channel,
          "data": []
        }
      }
      else if (data.sub_query_type === "compare") {
        pushItem = {
          "query": data.data[i * channel.length][0].info.query,
          "channel": channel,
          "data": []
        }
      }

      let pushDate = new Date(start_date);
      switch (options.timeunit) {
        case "daily": {
          for (let j = 0; j < diff_date + 1; j++) {
            pushItem.data.push({
              "date": pushDate.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-"),
            })
            channel.forEach((ch) => {
              pushItem.data[j][ch] = 0;
            })
            pushDate.setDate(pushDate.getDate() + 1);
          }
          break;
        }
        case "weekly": {
          for (let j = 0; j < diff_date + 1; j++) {
            if (j % 7 == 0) {
              pushItem.data.push({
                "date": pushDate.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-"),
                "end_date": "",
              })
              channel.forEach((ch) => {
                pushItem.data[parseInt(j / 7)][ch] = 0;
              })
            }
            if (j % 7 == 6 || j == diff_date) {
              pushItem.data[parseInt(j / 7)]['end_date'] = pushDate.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-")
            }
            pushDate.setDate(pushDate.getDate() + 1);
          }
          break;
        }
        case "monthly": {
          let diff_year = end_date.getFullYear() - start_date.getFullYear();
          let diff_month = end_date.getMonth() - start_date.getMonth();
          let diff_total_month = diff_year * 12 + diff_month;

          for (let j = 0; j < diff_total_month + 1; j++) {
            pushItem.data.push({
              "date": pushDate.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-"),
              "end_date": "",
            })
            if (j == diff_total_month) {
              pushItem.data[j]['end_date'] = end_date.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-");
            }
            else {
              pushDate.setFullYear(pushDate.getFullYear(), pushDate.getMonth() + 1, 0);
              pushItem.data[j]['end_date'] = pushDate.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-");
            }

            channel.forEach((ch) => {
              pushItem.data[j][ch] = 0;
            })

            pushDate.setFullYear(pushDate.getFullYear(), pushDate.getMonth() + 1, 1);
          }
          break;
        }
        default:
          break;
      }
      retDataSet.push(pushItem);
    }

    switch (options.timeunit) {
      case "daily": {
        data.data.forEach((item) => {
          item.forEach((subItem) => {
            retDataSet.forEach((retData) => {
              if (arrayCompare(subItem['info'].query, retData.query)) {
                retData.data.filter((retDataItem) => retDataItem.date.replace(/\-/g, "") == subItem[data.report_type].date).forEach((filteredItem) => {
                  filteredItem[subItem['info'].channel] = subItem[data.report_type].frequency;
                })
              }
            })
          })
        })
        break;
      }
      case "weekly": {
        data.data.forEach((item) => {
          item.forEach((subItem) => {
            retDataSet.forEach((retData) => {
              if (arrayCompare(subItem['info'].query, retData.query)) {
                retData.data.filter((retDataItem) => retDataItem.date.replace(/\-/g, "") <= subItem[data.report_type].date && retDataItem.end_date.replace(/\-/g, "") >= subItem[data.report_type].date).forEach((filteredItem) => {
                  filteredItem[subItem['info'].channel] += subItem[data.report_type].frequency;
                });
              }
            })
          })
        })
        break;
      }
      case "monthly": {
        data.data.forEach((item) => {
          item.forEach((subItem) => {
            retDataSet.forEach((retData) => {
              if (arrayCompare(subItem['info'].query, retData.query)) {
                retData.data.filter((retDataItem) => retDataItem.date.replace(/\-/g, "") <= subItem[data.report_type].date && retDataItem.end_date.replace(/\-/g, "") >= subItem[data.report_type].date).forEach((filteredItem) => {
                  filteredItem[subItem['info'].channel] += subItem[data.report_type].frequency;
                });
              }
            })
          })
        })
        break;
      }
      default:
        break;
    }
  }
  else if (data.report_type === "sentiment") {
    switch (options.timeunit) {
      case "daily": {
        data.data.forEach((item) => {
          let sentimentList = [];
          item.sentiment.forEach(sentimentItem => {
            sentimentList.push({
              "date": sentimentItem['date'].replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3'),
              "positive": sentimentItem['positive'].freq,
              "negative": sentimentItem['negative'].freq,
              "neutral": sentimentItem['neutral'].freq,
              "mix": sentimentItem['mix'].freq
            })
          })
          retDataSet.push({
            "data": sentimentList,
            "channel": item['info'].channel,
            "query": item['info'].query
          });
        })
        break;
      }
      case "weekly": {
        data.data.forEach((item) => {
          let sentimentList = [];

          item.sentiment.forEach((sentimentItem, sentimentIndex) => {
            if (sentimentIndex % 7 == 0) {
              sentimentList.push({
                "date": sentimentItem['date'].replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3'),
              })
              sentimentList[parseInt(sentimentIndex / 7)]['positive'] = sentimentItem['positive'].freq;
              sentimentList[parseInt(sentimentIndex / 7)]['negative'] = sentimentItem['negative'].freq;
              sentimentList[parseInt(sentimentIndex / 7)]['mix'] = sentimentItem['mix'].freq;
              sentimentList[parseInt(sentimentIndex / 7)]['neutral'] = sentimentItem['neutral'].freq;
            }
            else {
              sentimentList[parseInt(sentimentIndex / 7)]['positive'] += sentimentItem['positive'].freq;
              sentimentList[parseInt(sentimentIndex / 7)]['negative'] += sentimentItem['negative'].freq;
              sentimentList[parseInt(sentimentIndex / 7)]['mix'] += sentimentItem['mix'].freq;
              sentimentList[parseInt(sentimentIndex / 7)]['neutral'] += sentimentItem['neutral'].freq;
            }
            if (sentimentIndex % 7 == 6 || sentimentIndex == diff_date) {
              sentimentList[parseInt(sentimentIndex / 7)]['end_date'] = sentimentItem['date'].replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3')
            }
          })
          retDataSet.push({
            "data": sentimentList,
            "channel": item['info'].channel,
            "query": item['info'].query
          });
        })
        break;
      }
      case "monthly": {
        let diff_year = end_date.getFullYear() - start_date.getFullYear();
        let diff_month = end_date.getMonth() - start_date.getMonth();
        let diff_total_month = diff_year * 12 + diff_month;

        data.data.forEach((item) => {
          let sentimentList = [];
          let pushDate = new Date(start_date);

          for (let j = 0; j < diff_total_month + 1; j++) {
            sentimentList.push({
              "date": pushDate.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-"),
              "end_date": "",
              "positive": 0,
              "negative": 0,
              "mix": 0,
              "neutral": 0
            })
            if (j == diff_total_month) {
              sentimentList[j]['end_date'] = end_date.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-");
            }
            else {
              pushDate.setFullYear(pushDate.getFullYear(), pushDate.getMonth() + 1, 0);
              sentimentList[j]['end_date'] = pushDate.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-");
            }
            pushDate.setFullYear(pushDate.getFullYear(), pushDate.getMonth() + 1, 1);
          }

          item.sentiment.forEach((sentimentItem, sentimentIndex) => {
            sentimentList.filter((sentimentListItem) => sentimentListItem.date.replace(/\-/g, "") <= sentimentItem.date && sentimentListItem.end_date.replace(/\-/g, "") >= sentimentItem.date).forEach((filteredItem) => {
              filteredItem.positive += sentimentItem.positive.freq;
              filteredItem.negative += sentimentItem.negative.freq;
              filteredItem.mix += sentimentItem.mix.freq;
              filteredItem.neutral += sentimentItem.neutral.freq;
            })
          })

          retDataSet.push({
            "data": sentimentList,
            "channel": item['info'].channel,
            "query": item['info'].query
          });
        })
        break;
      }
      default:
        break;
    }
  }
  else if (data.report_type === "source") {
    retDataSet = data.data;
  }
  else if (data.report_type === "category") {
    data.data.forEach((item => {
      let categoryDataList = [];
      let category_01_Children = [];
      item.content.some((contentItem, contentIndex) => {
        let category_02_Children = [];
        contentItem.content.some((contentChildren, index) => {
          if (index == 50) {
            return true;
          }
          else {
            category_02_Children.push({
              "name": contentChildren.word,
              "value": contentChildren.freq,
              "category": contentItem.category,
              "color": CATEGORY_COLOR_SET[contentItem.category],
              "name-value": `${contentChildren.word}, ${contentChildren.freq}`
            })
          }
        })

        category_01_Children.push({
          "name": contentItem.category,
          "color": CATEGORY_COLOR_SET[contentItem.category],
          "value": contentItem.freq,
          "children": category_02_Children,
          "name-value": `${contentItem.category}, ${contentItem.freq}`
        })
      })
      categoryDataList.push({
        "name": item.info.query.join(' & '),
        // "color": '',
        // "value": '',
        "children": category_01_Children,
        "value": 0,
        "name-value": item.info.query.join(' & ')
      })

      retDataSet.push({
        "data": categoryDataList,
        "channel": item['info'].channel,
        "query": item['info'].query
      })
    }))
  }
  else if (data.report_type === "buzzlist") {
    retDataSet = data.data;
  }
  else if (data.report_type === "channel_buzzlist") {
    retDataSet = data.data;
  }
  else if (data.report_type === "relation") {
    switch (options.timeunit) {
      case "daily": {
        data.data.forEach(item => {
          let keywordDataList = [];
          item.daily.forEach((keywordArray, keywordArrayIndex) => {
            if (keywordArray.date == 'all') {
              keywordDataList.push({
                "date": `${start_date.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-")} ~ ${end_date.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-")}`,
                "data": []
              })
            }
            else {
              keywordDataList.push({
                "date": keywordArray.date,
                "data": []
              })
            }
            keywordArray.keyword.some((keywordItem, keywordIndex) => {
              if (keywordIndex == options.words) {
                return true;
              }
              else {
                if (options.morph == "verb") {
                  keywordDataList[keywordArrayIndex].data.push({
                    "text": keywordItem.keyword + "다",
                    "value": keywordItem.count
                  });
                }
                else {
                  keywordDataList[keywordArrayIndex].data.push({
                    "text": keywordItem.keyword,
                    "value": keywordItem.count
                  });
                }
              }
            })
          })

          let keywordExcelDataList = [];
          keywordExcelDataList.push({
            "date": `${start_date.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-")} ~ ${end_date.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-")}`,
            "data": []
          })
          item.all.data.some((keywordItem, keywordIndex) => {
            if (keywordIndex == options.words) {
              return true;
            }
            else {
              if (options.morph == "verb") {
                keywordExcelDataList[0].data.push({
                  "text": keywordItem.keyword + "다",
                  "value": keywordItem.count
                });
              }
              else {
                keywordExcelDataList[0].data.push({
                  "text": keywordItem.keyword,
                  "value": keywordItem.count
                });
              }
            }
          })

          retDataSet.push({
            "data": keywordDataList,
            "excelData": keywordExcelDataList,
            "channel": item['info'].channel,
            "query": item['info'].query
          })
        })
        break;
      }
      case "weekly": {
        data.data.forEach(item => {
          let keywordDataList = [];
          item.weekly.data.forEach((keywordArray, keywordArrayIndex) => {
            if (keywordArray.date == 'all') {
              keywordDataList.push({
                "date": `${start_date.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-")} ~ ${end_date.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-")}`,
                "data": []
              })
            }
            else {
              keywordDataList.push({
                "date": `${keywordArray.date} ~ ${keywordArray['end_date']}`,
                "data": []
              })
            }
            keywordArray.keyword.some((keywordItem, keywordIndex) => {
              if (keywordIndex == options.words) {
                return true;
              }
              else {
                if (options.morph == "verb") {
                  keywordDataList[keywordArrayIndex].data.push({
                    "text": keywordItem.keyword + "다",
                    "value": keywordItem.count
                  });
                }
                else {
                  keywordDataList[keywordArrayIndex].data.push({
                    "text": keywordItem.keyword,
                    "value": keywordItem.count
                  });
                }
              }
            })
          })


          let keywordExcelDataList = [];
          keywordExcelDataList.push({
            "date": `${start_date.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-")} ~ ${end_date.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-")}`,
            "data": []
          })
          item.all.data.some((keywordItem, keywordIndex) => {
            if (keywordIndex == options.words) {
              return true;
            }
            else {
              if (options.morph == "verb") {
                keywordExcelDataList[0].data.push({
                  "text": keywordItem.keyword + "다",
                  "value": keywordItem.count
                });
              }
              else {
                keywordExcelDataList[0].data.push({
                  "text": keywordItem.keyword,
                  "value": keywordItem.count
                });
              }
            }
          })

          retDataSet.push({
            "data": keywordDataList,
            "excelData": keywordExcelDataList,
            "channel": item['info'].channel,
            "query": item['info'].query
          })
        })
        break;
      }
      case "monthly": {
        data.data.forEach(item => {
          let keywordDataList = [];
          item.monthly.data.forEach((keywordArray, keywordArrayIndex) => {
            if (keywordArray.date == 'all') {
              keywordDataList.push({
                "date": `${start_date.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-")} ~ ${end_date.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-")}`,
                "data": []
              })
            }
            else {
              keywordDataList.push({
                "date": keywordArray.date,
                "data": []
              })
            }

            keywordArray.keyword.some((keywordItem, keywordIndex) => {
              if (keywordIndex == options.words) {
                return true;
              }
              else {
                if (options.morph == "verb") {
                  keywordDataList[keywordArrayIndex].data.push({
                    "text": keywordItem.keyword + "다",
                    "value": keywordItem.count
                  });
                }
                else {
                  keywordDataList[keywordArrayIndex].data.push({
                    "text": keywordItem.keyword,
                    "value": keywordItem.count
                  });
                }
              }
            })
          })

          let keywordExcelDataList = [];
          keywordExcelDataList.push({
            "date": `${start_date.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-")} ~ ${end_date.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-")}`,
            "data": []
          })
          item.all.data.some((keywordItem, keywordIndex) => {
            if (keywordIndex == options.words) {
              return true;
            }
            else {
              if (options.morph == "verb") {
                keywordExcelDataList[0].data.push({
                  "text": keywordItem.keyword + "다",
                  "value": keywordItem.count
                });
              }
              else {
                keywordExcelDataList[0].data.push({
                  "text": keywordItem.keyword,
                  "value": keywordItem.count
                });
              }
            }
          })

          retDataSet.push({
            "data": keywordDataList,
            "excelData": keywordExcelDataList,
            "channel": item['info'].channel,
            "query": item['info'].query
          })
        })
        break;
      }
      case "all": {
        data.data.forEach(item => {
          let keywordDataList = [];
          keywordDataList.push({
            "date": `${start_date.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-")} ~ ${end_date.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-")}`,
            "data": []
          })
          item.all.data.some((keywordItem, keywordIndex) => {
            if (keywordIndex == options.words) {
              return true;
            }
            else {
              if (options.morph == "verb") {
                keywordDataList[0].data.push({
                  "text": keywordItem.keyword + "다",
                  "value": keywordItem.count
                });
              }
              else {
                keywordDataList[0].data.push({
                  "text": keywordItem.keyword,
                  "value": keywordItem.count
                });
              }
            }
          })

          retDataSet.push({
            "data": keywordDataList,
            "excelData": keywordDataList,
            "channel": item['info'].channel,
            "query": item['info'].query
          })
        })
        break;
      }
      default:
        break;
    }
  }
  else if (data.report_type === "positioningmap") {
    channel.forEach(channelItem => {
      let positioningmapDataList = [];
      data.data.filter(dataItem => dataItem.channel == channelItem).forEach((dataItem, index) => {
        let colorIndex = index;
        while (colorIndex >= POSITIONINGMAP_COLOR_SET.length) {
          colorIndex = colorIndex - POSITIONINGMAP_COLOR_SET.length;
        }

        if (dataItem.total == 0) {
          positioningmapDataList.push({
            "title": dataItem.name.join(' & '),
            "x": dataItem.negative.value + dataItem.positive.value,
            "y": 0,
            "value": dataItem.total,
            "negative": dataItem.negative,
            "positive": dataItem.positive,
            "color": POSITIONINGMAP_COLOR_SET[colorIndex]
          })
        }
        else {
          positioningmapDataList.push({
            "title": dataItem.name.join(' & '),
            "x": dataItem.negative.value + dataItem.positive.value,
            "y": dataItem.psr,
            "value": dataItem.total,
            "negative": dataItem.negative,
            "positive": dataItem.positive,
            "color": POSITIONINGMAP_COLOR_SET[colorIndex]
          })
        }
      })

      retDataSet.push({
        "channel": channelItem,
        "data": positioningmapDataList
      })
    })
  }
  else if (data.report_type === "emotion") {
    switch (options.timeunit) {
      case "daily": {
        data.data.forEach((item) => {
          let emotionList = [];
          item.emotion.forEach(emotionItem => {
            emotionList.push({
              "date": emotionItem['date'].replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3'),
              'pleasure': emotionItem['pleasure'].freq,
              'aversion': emotionItem['aversion'].freq,
              'fear': emotionItem['fear'].freq,
              'surprised': emotionItem['surprised'].freq,
              'anger': emotionItem['anger'].freq,
              'ache': emotionItem['ache'].freq,
              'interest': emotionItem['interest'].freq,
              'boring': emotionItem['boring'].freq,
              'sadness': emotionItem['sadness'].freq,
              'etc': emotionItem['etc'].freq
            })
          })
          retDataSet.push({
            "data": emotionList,
            "channel": item['info'].channel,
            "query": item['info'].query
          });
        })
        break;
      }
      case "weekly": {
        data.data.forEach((item) => {
          let emotionList = [];

          item.emotion.forEach((emotionItem, emotionIndex) => {
            if (emotionIndex % 7 == 0) {
              emotionList.push({
                "date": emotionItem['date'].replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3'),
              })
              emotionList[parseInt(emotionIndex / 7)]['pleasure'] = emotionItem['pleasure'].freq;
              emotionList[parseInt(emotionIndex / 7)]['aversion'] = emotionItem['aversion'].freq;
              emotionList[parseInt(emotionIndex / 7)]['fear'] = emotionItem['fear'].freq;
              emotionList[parseInt(emotionIndex / 7)]['surprised'] = emotionItem['surprised'].freq;
              emotionList[parseInt(emotionIndex / 7)]['anger'] = emotionItem['anger'].freq;
              emotionList[parseInt(emotionIndex / 7)]['ache'] = emotionItem['ache'].freq;
              emotionList[parseInt(emotionIndex / 7)]['interest'] = emotionItem['interest'].freq;
              emotionList[parseInt(emotionIndex / 7)]['boring'] = emotionItem['boring'].freq;
              emotionList[parseInt(emotionIndex / 7)]['sadness'] = emotionItem['sadness'].freq;
              emotionList[parseInt(emotionIndex / 7)]['etc'] = emotionItem['etc'].freq;
            }
            else {
              emotionList[parseInt(emotionIndex / 7)]['pleasure'] += emotionItem['pleasure'].freq;
              emotionList[parseInt(emotionIndex / 7)]['aversion'] += emotionItem['aversion'].freq;
              emotionList[parseInt(emotionIndex / 7)]['fear'] += emotionItem['fear'].freq;
              emotionList[parseInt(emotionIndex / 7)]['surprised'] += emotionItem['surprised'].freq;
              emotionList[parseInt(emotionIndex / 7)]['anger'] += emotionItem['anger'].freq;
              emotionList[parseInt(emotionIndex / 7)]['ache'] += emotionItem['ache'].freq;
              emotionList[parseInt(emotionIndex / 7)]['interest'] += emotionItem['interest'].freq;
              emotionList[parseInt(emotionIndex / 7)]['boring'] += emotionItem['boring'].freq;
              emotionList[parseInt(emotionIndex / 7)]['sadness'] += emotionItem['sadness'].freq;
              emotionList[parseInt(emotionIndex / 7)]['etc'] += emotionItem['etc'].freq;
            }
            if (emotionIndex % 7 == 6 || emotionIndex == diff_date) {
              emotionList[parseInt(emotionIndex / 7)]['end_date'] = emotionItem['date'].replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3')
            }
          })
          retDataSet.push({
            "data": emotionList,
            "channel": item['info'].channel,
            "query": item['info'].query
          });
        })
        break;
      }
      case "monthly": {
        let diff_year = end_date.getFullYear() - start_date.getFullYear();
        let diff_month = end_date.getMonth() - start_date.getMonth();
        let diff_total_month = diff_year * 12 + diff_month;

        data.data.forEach((item) => {
          let emotionList = [];
          let pushDate = new Date(start_date);

          for (let j = 0; j < diff_total_month + 1; j++) {
            emotionList.push({
              "date": pushDate.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-"),
              "end_date": "",
              'pleasure': 0,
              'aversion': 0,
              'fear': 0,
              'surprised': 0,
              'anger': 0,
              'ache': 0,
              'interest': 0,
              'boring': 0,
              'sadness': 0,
              'etc': 0
            })
            if (j == diff_total_month) {
              emotionList[j]['end_date'] = end_date.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-");
            }
            else {
              pushDate.setFullYear(pushDate.getFullYear(), pushDate.getMonth() + 1, 0);
              emotionList[j]['end_date'] = pushDate.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-");
            }
            pushDate.setFullYear(pushDate.getFullYear(), pushDate.getMonth() + 1, 1);
          }

          item.emotion.forEach((emotionItem, emotionIndex) => {
            emotionList.filter((emotionListItem) => emotionListItem.date.replace(/\-/g, "") <= emotionItem.date && emotionListItem.end_date.replace(/\-/g, "") >= emotionItem.date).forEach((filteredItem) => {
              filteredItem.pleasure += emotionItem.pleasure.freq;
              filteredItem.aversion += emotionItem.aversion.freq;
              filteredItem.fear += emotionItem.fear.freq;
              filteredItem.surprised += emotionItem.surprised.freq;
              filteredItem.anger += emotionItem.anger.freq;
              filteredItem.ache += emotionItem.ache.freq;
              filteredItem.interest += emotionItem.interest.freq;
              filteredItem.boring += emotionItem.boring.freq;
              filteredItem.sadness += emotionItem.sadness.freq;
              filteredItem.etc += emotionItem.etc.freq;
            })
          })

          retDataSet.push({
            "data": emotionList,
            "channel": item['info'].channel,
            "query": item['info'].query
          });
        })
        break;
      }
      default:
        break;
    }
  }

  retDataJson.subQuery = [];
  retDataJson.reportData = retDataSet;
  retDataJson.name = data.name;
  retDataJson.dateRange = `${start_date.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-")} ~ ${end_date.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-")}`;
  retDataJson.reportType = data.report_type;
  retDataJson.reTweet = data.reTweet.toString();
  retDataJson.subQueryType = data.sub_query_type;
  data.query.forEach((item, index) => {
    if (index == 0) {
      retDataJson.mainQuery = item;
    }
    else {
      retDataJson.subQuery.push(item);
    }
  })
  retDataJson.channels = data.channel;
  retDataJson.options = options;

  return retDataJson;
}

export default JSONtoReportData;